import { usePhysicalStoreData } from '@/data/Content/usePhysicalStoreData';
import { useStoreIDS } from '@/data/state/useStoreIDs';
import { ProductType } from '@/data/types/Product';
import { Box } from '@mui/material';
import { FC } from 'react';
import { HomeDeliveryDateLabel } from '@/components/blocks/DeliveryPickupDates/parts/HomeDeliveryDateLabel';
import { PickupDateLabel } from '@/components/blocks/DeliveryPickupDates/parts/PickupDateLabel';
import { containerSx } from '@/components/blocks/DeliveryPickupDates/styles/deliveryPickupDates';

type Props = {
	product: ProductType;
};

/**
 * PLP product card "Delivery/Pickup container" (story 158621 + 159042): shows
 * the store-pickup date, then the home-delivery date, each with reserved height
 * so a "no label" state doesn't shift surrounding layout (AC15/AC29).
 */
export const DeliveryPickupDates: FC<Props> = ({ product }) => {
	const { physicalStoreId } = useStoreIDS();
	const { storeName } = usePhysicalStoreData({ physicalStoreId });

	return (
		<Box sx={containerSx}>
			<PickupDateLabel
				product={product}
				physicalStoreId={physicalStoreId}
				storeName={storeName as string}
			/>
			<HomeDeliveryDateLabel product={product} physicalStoreId={physicalStoreId} />
		</Box>
	);
};
